import React from 'react'
import { isNil } from 'lodash'
import { IconNotebook } from '@tabler/icons-react'

import { Banner } from '@/components/banners/Banner'
import { Button } from '@/components/buttons/Button'

/**
 * Offers to index a OneNote notebook that a Whole site row skips, because
 * Whole site leaves out Site Assets, where SharePoint keeps a site's notebooks.
 *
 * @param {Object} props.notebook { site_path, name, section_count, last_seen_at }
 * @param {string} props.disabledReason why Index is unavailable right now, or null
 * @param {boolean} props.indexing whether the Index request is in flight
 * @param {Function} props.onIndex adds a Site Assets row for the notebook's site
 * @param {Function} props.onDismiss hides the banner for this notebook in this browser
 */
export const NotebookSuggestionBanner = ({
  notebook,
  disabledReason = null,
  indexing = false,
  onIndex,
  onDismiss,
}) => (
  <Banner informative icon={<IconNotebook />} data-testid="sharepoint-notebook-suggestion">
    <div className="flex-column small-gap">
      <strong>We found a OneNote notebook that isn’t being indexed</strong>
      <p>
        <strong>{notebook.name}</strong> is in Site Assets on <strong>{notebook.site_path}</strong>.
        Whole site skips Site Assets because SharePoint mostly fills it with the images and files it
        uses to build your pages, so notebooks need their own row.
      </p>
      <div className="flex-align-center small-gap">
        <Button
          brand
          xs
          loading={indexing}
          disabled={!isNil(disabledReason)}
          disabledTooltip={disabledReason}
          onClick={onIndex}
        >
          Index this notebook
        </Button>
        <Button xs disabled={indexing} onClick={onDismiss}>
          Not now
        </Button>
      </div>
    </div>
  </Banner>
)
